export enum CompanySettingCategory {
  PrivacySettings = "Privacy Settings"
}
